import Steps6 from './Steps6'
export default Steps6
